import { render } from "./SecundaryButton.vue?vue&type=template&id=b8f88436&scoped=true"
import script from "./SecundaryButton.vue?vue&type=script&lang=js"
export * from "./SecundaryButton.vue?vue&type=script&lang=js"

import "./SecundaryButton.vue?vue&type=style&index=0&id=b8f88436&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f88436"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
